import ArrowUp from './arrowUp';

export default ArrowUp;
